import {
  Box,
  Icon,
  IconName,
  Text,
  useForegroundVariantColor,
  useTheme
} from "@seneca/senekit";

import { SIDEBAR_MENU_ITEM_HEIGHT } from "../../components/SidebarMenuItem/SidebarMenuItem";

type Props = {
  label: string;
  iconName: IconName;
  onClick: () => void;
};

export default function NewChatItem({ label, iconName, onClick }: Props) {
  const theme = useTheme();
  const foregroundVariantColor = useForegroundVariantColor("1");

  return (
    <Box
      component="button"
      onClick={onClick}
      width="100%"
      border="0"
      background="transparent"
      cursor="pointer"
      padding="none"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        paddingX="12"
        borderRadius="medium"
        height={`${SIDEBAR_MENU_ITEM_HEIGHT}px`}
        backgroundColor={theme.foreground}
        hoverStyles={{
          backgroundColor: foregroundVariantColor
        }}
      >
        <Text tone="neutral" weight="bold">
          {label}
        </Text>
        <Icon
          iconName={iconName}
          tone="neutral"
          accessibilityLabel={null}
          size="large"
        />
      </Box>
    </Box>
  );
}
